import { Component, OnInit } from '@angular/core';
import { AuthService } from './../app/auth/auth.service';
import { CognitoService } from "./services/cognito.service";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'iVago-app';

  isLoggedIn$: any;
  isMenuVisible: boolean = true; // Variable para controlar
  isLoaderVisible: boolean = true; // Variable para controlar
  
  constructor(private auth: AuthService, public cognitoService: CognitoService, private router: Router) {
    this.isLoggedIn$ = false;
  }

  ngOnInit() {
    (async () => {
      if (await this.cognitoService.isAuthenticated()) {
        this.isLoggedIn$ = true;
      }
    })();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Verificar la ruta actual
      const currentRoute = event.urlAfterRedirects;
      const contentt = document.querySelector('.contentt');

      if(currentRoute.startsWith('/trainer/rutinas/') || currentRoute.startsWith('/trainer/guias/')){
        this.isMenuVisible = false;
        contentt?.classList.remove('content-wrapper');
      }
      else{
        this.isMenuVisible = true;
        contentt?.classList.add('content-wrapper');
      }

      if(currentRoute.startsWith('/trainer/config-programa/') || currentRoute.startsWith('/trainer/config-programa/')){
        this.isLoaderVisible = false;
      }else{
        this.isLoaderVisible = true;
      }

    });
  }
}
